<template>
  <div v-if="isVisible" class="modal-overlay" @click="closeModal">
    <div class="modal-container" @click.stop>
      <button class="close-btn" @click="closeModal">×</button>
      
      <h2 class="modal-title">修改密码</h2>
      
      <!-- 用户信息区域 -->
      <div class="user-info-section">
        <div class="info-row">
          <span class="info-label">用户名:</span>
          <span class="info-value">{{ userInfo.userToken }}</span>
        </div>
        <div v-if="userInfo.email" class="info-row">
          <span class="info-label">邮箱:</span>
          <span class="info-value">{{ userInfo.email }}</span>
        </div>
      </div>
      
      <!-- 密码输入区域 -->
      <div class="password-section">
        <!-- 旧密码 -->
        <div class="input-wrapper">
          <label class="password-label">
            <span class="required">*</span> 旧密码
          </label>
          <div class="password-input-container">
            <input 
              :type="showOldPassword ? 'text' : 'password'"
              v-model="formData.oldPassword"
              class="password-input"
              placeholder="请输入旧密码"
              @blur="validateField('oldPassword')"
              :disabled="isLoading"
            />
            <!-- 眼睛图标 -->
            <svg 
              v-if="!showOldPassword"
              class="eye-icon" 
              @click="toggleOldPasswordVisibility"
              viewBox="0 0 576 512" 
              height="1em" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
            </svg>
            <svg 
              v-else
              class="eye-icon" 
              @click="toggleOldPasswordVisibility"
              viewBox="0 0 640 512" 
              height="1em" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"></path>
            </svg>
          </div>
          <div v-if="errors.oldPassword" class="field-error">{{ errors.oldPassword }}</div>
        </div>

        <!-- 新密码 -->
        <div class="input-wrapper">
          <label class="password-label">
            <span class="required">*</span> 新密码
          </label>
          <div class="password-input-container">
            <input 
              :type="showNewPassword ? 'text' : 'password'"
              v-model="formData.newPassword"
              class="password-input"
              placeholder="请输入新密码（至少6位）"
              @blur="validateField('newPassword')"
              :disabled="isLoading"
            />
            <!-- 眼睛图标 -->
            <svg 
              v-if="!showNewPassword"
              class="eye-icon" 
              @click="toggleNewPasswordVisibility"
              viewBox="0 0 576 512" 
              height="1em" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
            </svg>
            <svg 
              v-else
              class="eye-icon" 
              @click="toggleNewPasswordVisibility"
              viewBox="0 0 640 512" 
              height="1em" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"></path>
            </svg>
          </div>
          <div v-if="errors.newPassword" class="field-error">{{ errors.newPassword }}</div>
        </div>

        <!-- 确认新密码 -->
        <div class="input-wrapper">
          <label class="password-label">
            <span class="required">*</span> 确认新密码
          </label>
          <div class="password-input-container">
            <input 
              :type="showConfirmPassword ? 'text' : 'password'"
              v-model="formData.confirmPassword"
              class="password-input"
              placeholder="请再次输入新密码"
              @blur="validateField('confirmPassword')"
              @keyup.enter="handleChangePassword"
              :disabled="isLoading"
            />
            <!-- 眼睛图标 -->
            <svg 
              v-if="!showConfirmPassword"
              class="eye-icon" 
              @click="toggleConfirmPasswordVisibility"
              viewBox="0 0 576 512" 
              height="1em" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
            </svg>
            <svg 
              v-else
              class="eye-icon" 
              @click="toggleConfirmPasswordVisibility"
              viewBox="0 0 640 512" 
              height="1em" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"></path>
            </svg>
          </div>
          <div v-if="errors.confirmPassword" class="field-error">{{ errors.confirmPassword }}</div>
        </div>

        <!-- 错误提示 -->
        <div v-if="errorMessage" class="error-message">
          <span class="error-icon">⚠️</span>
          {{ errorMessage }}
        </div>
        
        <!-- 成功提示 -->
        <div v-if="successMessage" class="success-message">
          <span class="success-icon">✅</span>
          {{ successMessage }}
        </div>
      </div>
      
      <!-- 按钮区域 -->
      <div class="button-section">
        <button class="cancel-btn" @click="closeModal" :disabled="isLoading">取消</button>
        <button 
          class="confirm-btn" 
          @click="handleChangePassword"
          :disabled="!isFormValid || isLoading"
        >
          <span v-if="!isLoading">确认修改</span>
          <span v-else class="loading-text">
            <span class="loading-spinner"></span>
            修改中...
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { changePassword } from '../api/home'
import { useRouter } from 'vue-router'

const router = useRouter()

defineProps({
  isVisible: {
    type: Boolean,
    default: false
  },
  userInfo: {
    type: Object,
    default: () => ({
      userToken: '',
      email: ''
    })
  }
})

const emit = defineEmits(['close', 'success'])

const formData = ref({
  oldPassword: '',
  newPassword: '',
  confirmPassword: ''
})

const errors = ref({
  oldPassword: '',
  newPassword: '',
  confirmPassword: ''
})

const showOldPassword = ref(false)
const showNewPassword = ref(false)
const showConfirmPassword = ref(false)
const isLoading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')

// 验证密码（与注册页面保持一致）
const validatePassword = (password) => {
  if (!password) return ''
  if (password.length < 6) return '密码至少6位'
  return ''
}

// 验证确认密码
const validateConfirmPassword = (confirmPassword) => {
  if (!confirmPassword) return ''
  if (confirmPassword !== formData.value.newPassword) return '两次密码不一致'
  return ''
}

// 验证字段
const validateField = (field) => {
  switch (field) {
    case 'oldPassword':
      if (!formData.value.oldPassword) {
        errors.value.oldPassword = ''
      } else {
        errors.value.oldPassword = validatePassword(formData.value.oldPassword)
      }
      break
    case 'newPassword':
      errors.value.newPassword = validatePassword(formData.value.newPassword)
      // 如果确认密码已经输入，重新验证确认密码
      if (formData.value.confirmPassword) {
        errors.value.confirmPassword = validateConfirmPassword(formData.value.confirmPassword)
      }
      break
    case 'confirmPassword':
      errors.value.confirmPassword = validateConfirmPassword(formData.value.confirmPassword)
      break
  }
}

// 表单是否有效
const isFormValid = computed(() => {
  return formData.value.oldPassword.trim() && 
         formData.value.newPassword.trim() && 
         formData.value.confirmPassword.trim()
})

// 切换密码可见性
const toggleOldPasswordVisibility = () => {
  showOldPassword.value = !showOldPassword.value
}

const toggleNewPasswordVisibility = () => {
  showNewPassword.value = !showNewPassword.value
}

const toggleConfirmPasswordVisibility = () => {
  showConfirmPassword.value = !showConfirmPassword.value
}

// 关闭弹窗
const closeModal = () => {
  formData.value = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  }
  errors.value = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  }
  showOldPassword.value = false
  showNewPassword.value = false
  showConfirmPassword.value = false
  errorMessage.value = ''
  successMessage.value = ''
  isLoading.value = false
  emit('close')
}

// 修改密码
const handleChangePassword = async () => {
  // 清空之前的消息
  errorMessage.value = ''
  successMessage.value = ''
  
  // 验证所有字段
  validateField('oldPassword')
  validateField('newPassword')
  validateField('confirmPassword')
  
  // 检查是否有错误
  if (!formData.value.oldPassword) {
    errorMessage.value = '请输入旧密码'
    return
  }
  if (errors.value.oldPassword) {
    errorMessage.value = errors.value.oldPassword
    return
  }
  
  if (!formData.value.newPassword) {
    errorMessage.value = '请输入新密码'
    return
  }
  if (errors.value.newPassword) {
    errorMessage.value = errors.value.newPassword
    return
  }
  
  if (!formData.value.confirmPassword) {
    errorMessage.value = '请再次输入新密码'
    return
  }
  if (errors.value.confirmPassword) {
    errorMessage.value = errors.value.confirmPassword
    return
  }
  
  isLoading.value = true
  
  try {
    const response = await changePassword({
      oldPass: formData.value.oldPassword,
      newPass: formData.value.newPassword
    })
    
    if (response.code === 1) {
      successMessage.value = response.msg || '修改成功'
      
      // 修改成功后延迟关闭弹窗并跳转到登录页
      setTimeout(() => {
        closeModal()
        emit('success')
        
        // 清除 share-session cookie
        const domain = window.location.hostname
        document.cookie = 'share-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        document.cookie = `share-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`
        document.cookie = `share-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`
        
        // 清除 localStorage 中保存的账号信息
        localStorage.removeItem('savedUsername')
        localStorage.removeItem('savedPassword')
        
        // 跳转到登录页
        router.push('/login')
      }, 1500)
    } else if (response.code === -1) {
      closeModal()
      router.push('/login')
    } else {
      errorMessage.value = response.msg || '修改失败，用户不存在或密码错误'
    }
  } catch (error) {
    console.error('修改密码错误:', error)
    errorMessage.value = '网络错误，请检查连接后重试'
  } finally {
    isLoading.value = false
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.modal-container {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  width: 90%;
  max-width: 500px;
  min-width: 320px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: slideUp 0.3s ease;
  max-height: 90vh;
  overflow-y: auto;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(0, 0, 0, 0.05);
  color: #666;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: rgba(255, 107, 107, 0.1);
  color: #ff6b6b;
  transform: scale(1.1);
}

.modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0 0 20px 0;
  text-align: center;
}

.user-info-section {
  background: #f5f5f7;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding: 6px 0;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.password-section {
  margin-bottom: 24px;
}

.input-wrapper {
  margin-bottom: 20px;
}

.input-wrapper:last-child {
  margin-bottom: 0;
}

.password-label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}

.required {
  color: #ff4d4f;
  margin-right: 4px;
}

.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input {
  width: 100%;
  padding: 12px;
  padding-right: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  color: #333;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.password-input::placeholder {
  color: #999;
}

.password-input:focus {
  border-color: #7b5cff;
  box-shadow: 0 0 0 2px rgba(123, 92, 255, 0.1);
}

.password-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f5f5f5;
}

/* 隐藏浏览器默认的密码显示按钮 */
.password-input::-ms-reveal,
.password-input::-ms-clear {
  display: none;
}

.password-input::-webkit-contacts-auto-fill-button,
.password-input::-webkit-credentials-auto-fill-button {
  display: none;
}

.eye-icon {
  position: absolute;
  right: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  color: #666;
}

.eye-icon:hover {
  opacity: 0.7;
  color: #7b5cff;
}

.field-error {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 6px;
}

.error-message {
  display: flex;
  align-items: center;
  margin-top: 16px;
  padding: 10px 12px;
  background: #fff1f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  color: #ff4d4f;
  font-size: 13px;
}

.error-icon {
  margin-right: 6px;
  font-size: 14px;
}

.success-message {
  display: flex;
  align-items: center;
  margin-top: 16px;
  padding: 10px 12px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 6px;
  color: #52c41a;
  font-size: 13px;
}

.success-icon {
  margin-right: 6px;
  font-size: 14px;
}

.button-section {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.cancel-btn,
.confirm-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 80px;
}

.cancel-btn {
  background: #fff;
  color: #666;
  border: 1px solid #d9d9d9;
}

.cancel-btn:hover:not(:disabled) {
  color: #333;
  border-color: #333;
}

.confirm-btn {
  background: linear-gradient(135deg, #7b5cff, #9b7bff);
  color: white;
  box-shadow: 0 4px 12px rgba(123, 92, 255, 0.3);
}

.confirm-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(123, 92, 255, 0.4);
}

.confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.loading-text {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.loading-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #ffffff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 768px) {
  .modal-container {
    width: 90%;
    max-width: 400px;
    padding: 20px;
  }
}
</style>

